'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var _ComponentActionHandler = require('./ComponentActionHandler');
Object.keys(_ComponentActionHandler).forEach(function(key) {
    if (key === 'default' || key === '__esModule') return;
    if (key in exports && exports[key] === _ComponentActionHandler[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _ComponentActionHandler[key];
        }
    });
});
var _HotAreaActionHandler = require('./HotAreaActionHandler');
Object.keys(_HotAreaActionHandler).forEach(function(key) {
    if (key === 'default' || key === '__esModule') return;
    if (key in exports && exports[key] === _HotAreaActionHandler[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _HotAreaActionHandler[key];
        }
    });
});
if (!process.env.SSR) {
// console.log('process.env.SSR');
// require('intersection-observer-polyfill/index.global'); //eslint-disable-line
}
